/**
 * Page loader
 * - window.load 後にローダーを非表示
 * - 同時に .front-hero に is-loaded を付与（Hero 内のアニメーション発火）
 */
export const initPageLoader = () => {
  const loader = document.querySelector('[data-loader]');
  const hero = document.querySelector('.front-hero');

  const hideLoader = () => {
    if (loader) loader.classList.add('is-hidden');
    document.documentElement.classList.add('page-loaded');
  };

  const revealHero = () => {
    if (hero) hero.classList.add('is-loaded');
  };

  const reveal = () => {
    hideLoader();
    // ローダーが消えてから少し間を置いて Hero を発火
    window.setTimeout(revealHero, 600);
  };

  // すでにロード済みの場合
  if (document.readyState === 'complete') {
    window.setTimeout(reveal, 100);
    return;
  }

  window.addEventListener('load', () => {
    window.setTimeout(reveal, 250);
  });

  // セーフティ：5秒経っても発火していなければ強制表示
  window.setTimeout(reveal, 5000);
};
